module.exports = __webpack_public_path__ + "0b6a4374f6a769ed1aea62f09637cf4f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-70.svg
// module id = 593
// module chunks = 0